namespace Portico.Models.Enterprise {
    import pme = Portico.Models.Enterprise;

    export interface IEnrollRequestModel {
        accountCanUpdate: boolean;
        accountCanInsert: boolean;
        accountSkipSearch: boolean;
        partyCanUpdate: boolean;
        partyCanInsert: boolean;
        partySkipSearch: boolean;
		account: pme.Account;

		mapToEnterpriseCoordinatorAccountUpsearchRequestModel(sourceId?: number);
	}

	export class EnrollRequestModel implements IEnrollRequestModel {
		accountCanInsert: boolean;
		accountCanUpdate: boolean;
		accountSkipSearch: boolean;
		partyCanInsert: boolean;
		partyCanUpdate: boolean;
		partySkipSearch: boolean;
		account: pme.Account;

		constructor(obj?: IEnrollRequestModel) {
			this.accountCanInsert = true;
			this.accountCanUpdate = true;
			this.accountSkipSearch = false;
			this.partyCanInsert = true;
			this.partyCanUpdate = true;
			this.partySkipSearch = false;
			this.account = null;

			if (obj) {
				this.accountCanUpdate = _.get(obj, 'accountCanUpdate', this.accountCanUpdate);
				this.accountCanInsert = _.get(obj, 'accountCanInsert', this.accountCanInsert);
				this.accountSkipSearch = _.get(obj, 'accountSkipSearch', this.accountSkipSearch);
				this.partyCanUpdate = _.get(obj, 'partyCanUpdate', this.partyCanUpdate);
				this.partyCanInsert = _.get(obj, 'partyCanInsert', this.partyCanInsert);
				this.partySkipSearch = _.get(obj, 'partySkipSearch', this.partySkipSearch);

				if (obj.account) {
					this.account = new Account(obj.account);
				}
			}
		}

		mapToEnterpriseCoordinatorAccountUpsearchRequestModel(sourceId: number) {
			return this.account.mapToEnterpriseCoordinatorAccountUpsearchRequestModel(this.accountCanInsert, this.accountCanUpdate, this.accountSkipSearch, this.partyCanInsert, this.partyCanUpdate, this.partySkipSearch, sourceId);
		}
	}
}